import { Box, type SxProps, type Theme } from "@mui/material";
import { ReactElement } from "react";

import { SplashLogo } from "./SplashLogo.tsx";

export function SplashScreen(): ReactElement {
  return (
    <Box sx={containerSx}>
      <SplashLogo />
    </Box>
  );
}

const containerSx = {
  position: "fixed",
  inset: 0,
  display: "flex",
  justifyContent: "center",
  bgcolor: "background.main",
  pointerEvents: "none",
} satisfies SxProps<Theme>;
